module.exports = __webpack_public_path__ + "static/media/img_sketchtomail.b5e7b7c5.png";